// extracted by mini-css-extract-plugin
module.exports = {"btn":"MenuButton__btn__3vZQA","medium":"MenuButton__medium__31x-J MenuButton__btn__3vZQA","large":"MenuButton__large__3V7ck MenuButton__btn__3vZQA"};